export var BattleplanComponentType;
(function (BattleplanComponentType) {
    BattleplanComponentType["Twist"] = "twist";
    BattleplanComponentType["Ability"] = "ability";
    BattleplanComponentType["Scoring"] = "scoring";
})(BattleplanComponentType || (BattleplanComponentType = {}));
